import { http } from './request';
import type {
  Influencer,
  InfluencerDetailResponse,
  InfluencerSearchParams,
  CompetitorSearchRequest,
  SimilarInfluencerRequest,
  SimilarInfluencer,
  ScreeningTask,
  CreateScreeningTaskRequest,
  Candidate,
  EvaluateInfluencerRequest,
  InfluencerEvaluation,
  UpdateInfluencerTagsRequest,
} from '../types/scout';
import type { PaginationParams, AsyncTask } from '../types/api';

export const scoutApi = {
  // 红人搜索
  searchInfluencers: (params: InfluencerSearchParams) =>
    http.post<Influencer[]>('/api/v1/scout/search', params),

  // 竞品红人采集
  searchCompetitors: (data: CompetitorSearchRequest) =>
    http.post<AsyncTask>('/api/v1/scout/search/competitors', data),

  // 相似红人推荐
  searchSimilar: (data: SimilarInfluencerRequest) =>
    http.post<{ seed_influencer: { id: string; name: string }; similar_influencers: SimilarInfluencer[] }>('/api/v1/scout/search/similar', data),

  // 红人管理
  getInfluencers: (params?: PaginationParams) =>
    http.get<Influencer[]>('/api/v1/scout/influencers', params),

  getInfluencer: (influencerId: string) =>
    http.get<InfluencerDetailResponse>(`/api/v1/scout/influencers/${influencerId}`),

  updateInfluencerTags: (influencerId: string, data: UpdateInfluencerTagsRequest) =>
    http.put<void>(`/api/v1/scout/influencers/${influencerId}/tags`, data),

  // 红人评估
  evaluateInfluencer: (influencerId: string, data: EvaluateInfluencerRequest) =>
    http.post<InfluencerEvaluation>(`/api/v1/scout/influencers/${influencerId}/evaluate`, data),

  // 筛选任务
  getScreeningTasks: (params?: PaginationParams) =>
    http.get<ScreeningTask[]>('/api/v1/scout/screening-tasks', params),

  createScreeningTask: (data: CreateScreeningTaskRequest) =>
    http.post<ScreeningTask>('/api/v1/scout/screening-tasks', data),

  getScreeningTask: (taskId: string) =>
    http.get<ScreeningTask>(`/api/v1/scout/screening-tasks/${taskId}`),

  getCandidates: (taskId: string, params?: PaginationParams) =>
    http.get<Candidate[]>(`/api/v1/scout/screening-tasks/${taskId}/candidates`, params),

  addCandidate: (taskId: string, influencerId: string, matchScore?: number, dataSource?: string, notes?: string) =>
    http.post<Candidate>(`/api/v1/scout/screening-tasks/${taskId}/candidates`, { 
      influencer_id: influencerId,
      match_score: matchScore,
      data_source: dataSource,
      notes
    }),

  removeCandidate: (taskId: string, candidateId: string) =>
    http.delete<void>(`/api/v1/scout/screening-tasks/${taskId}/candidates/${candidateId}`),

  getEvaluationsByTask: (taskId: string, params?: PaginationParams) =>
    http.get<InfluencerEvaluation[]>(`/api/v1/scout/screening-tasks/${taskId}/evaluations`, params),

  getEvaluation: (evaluationId: string) =>
    http.get<InfluencerEvaluation>(`/api/v1/scout/evaluations/${evaluationId}`),
};
